/*
 * Page Name
 */

(function ($) {

    if (jQuery('.oneday_block02_box ._item').length > 0) {
        _heightline({
            itemClsName: '.oneday_block02_box ._title',
            itemPerRow: 3,
            device: 'pc'
        });
    }

})(jQuery);